module.exports = __webpack_public_path__ + "img/8-1@2x.7db63c2b.png";